// src/components/Authentication/RoleSelection.js

import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { FaUserShield, FaHome } from 'react-icons/fa';

export default function RoleSelection() {
  const { userRole } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (userRole !== 'Admin') {
      navigate('/', { replace: true }); // Redirect non-admin users to the main page
    }
  }, [userRole, navigate]);

  const handleMainPage = () => {
    navigate('/', { replace: true });
  };

  const handleAdminPanel = () => {
    navigate('/admin', { replace: true });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-primary to-secondary">
      <div className="bg-glassOverlay backdrop-blur-md p-8 rounded-lg shadow-lg w-80 text-center">
        <h2 className="text-3xl font-semibold mb-6 text-accentBlue flex items-center justify-center">
          <FaUserShield className="mr-2" /> Welcome, Admin
        </h2>
        <p className="mb-6">Choose where you want to navigate:</p>
        <div className="space-y-4">
          <button
            onClick={handleMainPage}
            className="bg-accentBlue hover:bg-accentBlueDark text-white font-semibold py-3 px-6 rounded-lg w-full flex items-center justify-center transition-colors duration-200"
          >
            <FaHome className="mr-2" /> Go to Main Page
          </button>
          <button
            onClick={handleAdminPanel}
            className="bg-accentOrange hover:bg-accentOrangeDark text-white font-semibold py-3 px-6 rounded-lg w-full flex items-center justify-center transition-colors duration-200"
          >
            <FaUserShield className="mr-2" /> Go to Admin Panel
          </button>
        </div>
      </div>
    </div>
  );
}
